import formatRupiah from "../../utils/FormatRupiah";
import formatTanggal from "../../utils/FormatTanggal";

const columns = [
  // {
  //   title: "Tanggal",
  //   dataIndex: "tgl",
  //   key: "tgl",
  //   render: (text) => <p>{formatTanggal(text)}</p>,
  // },
  {
    title: "Application ID",
    dataIndex: "id",
    key: "id",
    width: 120,
    render: (text) => <a>{text}</a>,
  },
  {
    title: "NAMA",
    dataIndex: "nama",
    key: "nama",
    // render: (text) => <a>{text}</a>,
  },
  {
    title: "NIK",
    dataIndex: "nik",
    key: "nik",
  },
  {
    title: "DOKUMEN 1",
    dataIndex: "doc1",
    key: "doc1",
    render: (text) => (
      <a
        href={text}
        // href="https://www.google.com"
        target="_blank"
        rel="noreferrer"
        style={{ color: "blue", textDecoration: "underline" }}
      >
        Download Disini
      </a>
    ),
  },
  {
    title: "DOKUMEN 2",
    dataIndex: "doc2",
    key: "doc2",
    render: (text) => (
      <a
        href={text}
        target="_blank"
        rel="noreferrer"
        style={{ color: "blue", textDecoration: "underline" }}
      >
        Download Disini
      </a>
    ),
  },
  {
    title: "STATUS",
    dataIndex: "is_survey",
    key: "is_survey",
    render: (text) => (
      <p className="capitalize font-semibold">
        {text == 1 ? "Approved" : "Rejected"}
      </p>
    ),
  },
];

const formValidation = [
  [
    {
      title: "No. Akun",
      key: "noAcc",
      placeholder: "Masukan No. Akun",
      type: "text",
      required: true,
      validationText: "nomor akun harus diisi!",
    },
    {
      title: "Nama Akun",
      key: "nameAcc",
      placeholder: "Masukan Nama Akun",
      type: "text",
      required: true,
      validationText: "nama akun harus diisi!",
    },
  ],
  {
    title: "Tanggal Masuk",
    key: "tgl",
    placeholder: "Masukan tanggal masuk Anggota",
    type: "dateTime",
    required: true,
    validationText: "tanggal masuk harus diisi!",
  },
  {
    title: "Keterangan",
    key: "keterangan",
    placeholder: "Masukan Keterangan",
    type: "textarea",
    required: true,
    validationText: "alamat harus diisi!",
  },
  [
    {
      title: "Debet",
      key: "debet",
      placeholder: "Masukan Debet",
      type: "number",
      required: true,
      validationText: "Debet harus diisi!",
    },
    {
      title: "Kredit",
      key: "kredit",
      placeholder: "Masukan Kredit",
      type: "number",
      required: true,
      validationText: "Kredit harus diisi!",
    },
    {
      title: "Saldo",
      key: "saldo",
      placeholder: "Masukan Saldo",
      type: "number",
      required: true,
      validationText: "Saldo harus diisi!",
    },
  ],
];

export { columns, formValidation };
